import React, { useState } from "react";
import { getFirstVariantValue, getParametrics, getProductListInfo } from "core-web/utils/accordions";

import Accordion from "./Accordion";
import Div from "theme/layouts/Div";
import { MORE_INFORMATION } from "theme/components/productPage/constants";
import PropTypes from "prop-types";
import TextComponent from "./TextComponent";
import TextStyles from "theme/components/text/TextStyles";
import Waterfall from "theme/layouts/Waterfall";
import colors from "theme/config/colors";
import { isEmpty } from "core-web/utils/object";
import styled from "theme/libs/styled";
import { useTranslation } from "react-i18next";

const DetailsItem = styled("div")`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    gap: 8px;
    border-radius: 12px;

    :last-of-type {
        margin-bottom: 24px;
    }
    :nth-child(odd) {
        background: ${({ theme }) => theme.colors.neutral_50};
    }
`;

const Accordions = ({ product, selectedVariant = {} }) => {
    const { t } = useTranslation();

    const [activeAccordionItem, setActiveAccordionItem] = useState("product_information");

    const { description, name, price, variants } = selectedVariant || product;
    // const variantDescription = selectedVariant
    //     ? getParametrics(selectedVariant?.parametrics || [], VARIANT_DESCRIPTION, false)?.value
    //     : null;

    const moreInformationParametrics =
        getParametrics(selectedVariant?.parametrics || [], MORE_INFORMATION, true) ||
        getParametrics(product.parametrics, MORE_INFORMATION, true);

    const productListInfo = getProductListInfo(product, isEmpty(selectedVariant || {}) ? null : selectedVariant);

    return (
        <Waterfall rowGap={["12px", null, null, null, "16px"]}>
            {!!productListInfo?.length && (
                <Accordion
                    label={t("views.product.headings.details")}
                    active={activeAccordionItem === "product_information"}
                    handleClick={() =>
                        setActiveAccordionItem(
                            activeAccordionItem === "product_information" ? null : "product_information",
                        )
                    }
                >
                    {productListInfo.map(({ values, key }) =>
                        values ? (
                            <DetailsItem key={key} p={["24px 16px", null, null, null, "24px"]}>
                                <TextStyles textStyles="Myriad Pro/14-100-semibold" color={colors.black_70}>
                                    {t(`views.product.product_information.${key}`)}
                                </TextStyles>

                                {values.map((value, i) => (
                                    <TextStyles key={value} textStyles="Myriad Pro/16-120">
                                        {`${value} ${i < values.length - 1 ? ", " : ""}`}
                                    </TextStyles>
                                ))}
                            </DetailsItem>
                        ) : null,
                    )}
                </Accordion>
            )}

            {!!moreInformationParametrics?.length && (
                <Accordion
                    label={t("pdp.more_information")}
                    active={activeAccordionItem === "moreInformation"}
                    handleClick={() =>
                        setActiveAccordionItem(activeAccordionItem === "moreInformation" ? null : "moreInformation")
                    }
                >
                    {moreInformationParametrics.map((parametric) => (
                        <Div key={parametric.code}>
                            <TextStyles textStyles="Buenos Aires/16-120 SemiBold" mb="16px">
                                {parametric.name}
                            </TextStyles>
                            <TextComponent html={parametric.value} />
                        </Div>
                    ))}
                </Accordion>
            )}
        </Waterfall>
    );
};

Accordions.propTypes = {
    product: PropTypes.object.isRequired,
    selectedVariant: PropTypes.object,
};

export default Accordions;
